import { createAxiosInstance } from './axios-setup';
import { debugLogger } from '../helpers/debugLogger.js';
import { errorLogger } from '../helpers/errorLogger.js';
import Jsona from 'jsona';

const jsonapiApi = createAxiosInstance();
const dataFormatter = new Jsona();

// Get cart data
jsonapiApi.getCart = async () => {
  try {
    const response = await jsonapiApi.get(Drupal.url(`jsonapi/carts`));

    if (response.data) {
      return dataFormatter.deserialize(response.data);
    }
  } catch (error) {
    debugLogger('Error fetching store data: ', error);
    return null;
  }
};

// Get order data
jsonapiApi.getOrder = async (orderUUID) => {
  try {

    const response = await jsonapiApi.get(Drupal.url(`jsonapi/commerce_order/default/${orderUUID}`))

    if (response.data) {
      return dataFormatter.deserialize(response.data);
    }
  } catch (error) {
    errorLogger('Error getting order: ', error);
    return false;
  }
};

// Get order item data
jsonapiApi.getOrderItem = async (orderItemUUID) => {
  try {

    const response = await jsonapiApi.get(Drupal.url(`jsonapi/commerce_order_item/default/${orderItemUUID}`))

    if (response.data) {
      return dataFormatter.deserialize(response.data);
    }
  } catch (error) {
    errorLogger('Error getting order item: ', error);
    return false;
  }
};

// Update cart data
jsonapiApi.patchOrder = async (cartUUID, itemData) => {
  try {
    const headers = {
      'Content-Type': 'application/vnd.api+json',
      Accept: 'application/vnd.api+json',
    }
    const url = Drupal.url(`jsonapi/commerce_order/default/${cartUUID}`);
    const payload = {
      data: itemData
    };

    const response = await jsonapiApi.patch(url, payload, { headers });
    if (response.status === 200) {
      debugLogger('Order patched successfully');
      return true;
    } else {
      errorLogger('Unexpected status code:', response.status);
      return false;
    }
  } catch (error) {
    errorLogger('Error patching order: ', error);
    return false;
  }
};

// Update cart item data
jsonapiApi.patchOrderItem = async (cartUUID, orderItemUUID, itemData) => {
  try {
    const headers = {
      'Content-Type': 'application/vnd.api+json',
       Accept: 'application/vnd.api+json',
    }
    const url = Drupal.url(`jsonapi/carts/${cartUUID}/items/${orderItemUUID}`);
    const payload = {
      data: itemData
    };

    const response = await jsonapiApi.patch(url, payload, { headers });
    if (response.status === 200) {
      debugLogger('Order item patched successfully');
      return true;
    } else {
      errorLogger('Unexpected status code:', response.status);
      return false;
    }
  } catch (error) {
    errorLogger('Error patching order item: ', error);
    return false;
  }
};

// Add product to cart
jsonapiApi.addProductToCart = async (payloadData, doRedirectToCart = false) => {
  try {
    const headers = {
      'Content-Type': 'application/vnd.api+json',
      Accept: 'application/vnd.api+json',
    }
    const url = Drupal.url(`jsonapi/cart/product/add`);
    const payload = {
      data: [payloadData]
    };

    const response = await jsonapiApi.post(url, payload, { headers });
    if (response.status === 200) {
      debugLogger('Product added to cart successfully');
      return true;
    } else {
      errorLogger('Unexpected status code:', response.status);
      return false;
    }
  } catch (error) {
    errorLogger('Error adding product to cart: ', error);
    return false;
  }
};

// Get detailed commerce product data
jsonapiApi.getProduct = async (productUUID, productType) => {
  try {
    // Convert commerce_product--adoption to commerce_product/adoption
    const url = 'jsonapi/' + productType.replace('--', '/')

    const response = await jsonapiApi.get(Drupal.url(`${url}/${productUUID}`));

    if (response.data) {
      return dataFormatter.deserialize(response.data);
    }
  } catch (error) {
    errorLogger('Error fetching product: ', error);

    return null;
  }
};

// Delete item from cart
jsonapiApi.deleteOrderItem = async (cartUUID, itemUUID) => {
  try {
    const url = Drupal.url(`jsonapi/carts/${cartUUID}/items`);
    const data = {
      data: [
        {
          type: 'commerce_order_item--default',
          id: itemUUID,
        },
      ],
    };

    const response = await jsonapiApi.delete(url, {
      data: data,
    });

    if (response.status === 204 || response.status === 200) {
      debugLogger('Order item deleted successfully');
      return true;
    } else {
      errorLogger('Unexpected status code:', response.status);
      return false;
    }
  } catch (error) {
    errorLogger('Error deleting order item: ', error);
    return false;
  }
};

// Get global information
jsonapiApi.getGlobalInformation = async (productUUID, productType) => {
  try {
    const response = await jsonapiApi.get(Drupal.url(`jsonapi/config_pages/global_information`));

    if (response.data) {
      return dataFormatter.deserialize(response.data)[0];
    }
  } catch (error) {
    errorLogger('Error fetching global information: ', error);

    return null;
  }
};

// Get user UUID
jsonapiApi.getUserUUID = async (productUUID, productType) => {
  try {
    const response = await jsonapiApi.get(Drupal.url('jsonapi/'));

    if (response.data.meta && response.data.meta.links.me.meta.id) {
      return response.data.meta.links.me.meta.id;
    }
  } catch (error) {
    errorLogger('Error user UUID: ', error);

    return null;
  }
};

// Get user data
jsonapiApi.getUser = async (userUUID) => {
  try {
    const response = await jsonapiApi.get(Drupal.url(`jsonapi/user/user/${userUUID}`));

    if (response.data) {
      return dataFormatter.deserialize(response.data);
    }
  } catch (error) {
    errorLogger('Error basic data: ', error);

    return null;
  }
};

// Start checkout
jsonapiApi.placeOrder = async (cartUUID) => {
  try {
    const response = await jsonapiApi.get(Drupal.url(`jsonapi/checkout/${cartUUID}`));

    debugLogger('checkout start response ', response)

    if (response.data) {
      return dataFormatter.deserialize(response.data);
    }
  } catch (error) {
    errorLogger('Error starting checkout: ', error);

    return null;
  }
};

export { jsonapiApi };
